var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 3.33317C3.11224 3.33317 2.90028 3.42097 2.744 3.57725C2.58772 3.73353 2.49992 3.94549 2.49992 4.1665V15.8332C2.49992 16.0542 2.58772 16.2661 2.744 16.4224C2.90028 16.5787 3.11224 16.6665 3.33325 16.6665H16.6666C16.8876 16.6665 17.0996 16.5787 17.2558 16.4224C17.4121 16.2661 17.4999 16.0542 17.4999 15.8332V6.6665C17.4999 6.44549 17.4121 6.23353 17.2558 6.07725C17.0996 5.92097 16.8876 5.83317 16.6666 5.83317H9.16659C8.88796 5.83317 8.62777 5.69392 8.47321 5.46209L7.05393 3.33317H3.33325ZM1.56548 2.39874C2.03433 1.9299 2.67021 1.6665 3.33325 1.6665H7.49992C7.77855 1.6665 8.03874 1.80575 8.19329 2.03759L9.61257 4.1665H16.6666C17.3296 4.1665 17.9655 4.4299 18.4344 4.89874C18.9032 5.36758 19.1666 6.00346 19.1666 6.6665V15.8332C19.1666 16.4962 18.9032 17.1321 18.4344 17.6009C17.9655 18.0698 17.3296 18.3332 16.6666 18.3332H3.33325C2.67021 18.3332 2.03433 18.0698 1.56548 17.6009C1.09664 17.1321 0.833252 16.4962 0.833252 15.8332V4.1665C0.833252 3.50346 1.09664 2.86758 1.56548 2.39874Z",
    fill: "#FCBF04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folderIcon.6a2263e1b89ff62f6bc0a18f26761beb.svg";
export { ForwardRef as ReactComponent };